import styled from 'styled-components';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Card } from '../../../CommonComponents/OPL/Card/Card';

export const Wrapper = styled(Box)({
  display: 'grid',
  placeContent: 'center',
  height: '100%',
});

export const StyledCard = styled(Card)({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: 640,
  padding: '48px 32px',
  margin: '0 auto',
});
